<template>
  <div class="container container--fluid">
    <v-row>
      <v-col cols="12">
        <PageTitle v-if="$route.name === 'dashboard.cert.edit'" icon="mdi-table-edit" text="تغییر سرتیفیکیت" />
        <PageTitle v-else icon="mdi-new-box" text="ساخت سرتیفیکیت" />
      </v-col>
      <v-col cols="12" class="pt-5">
        <CertForm />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PageTitle from "@/packages/dashboard/components/PageTitle";
import CertForm from "@/packages/dashboard/components/CertForm";
import { mapGetters } from "vuex";
export default {
  name: "Certificate",
  components: { CertForm, PageTitle },
  data: () => ({}),
  computed: {
    ...mapGetters({
      is_loading: "loading/is_loading",
    }),
  },
  methods: {},
};
</script>

<style scoped></style>
